import { render, staticRenderFns } from "./CreateLawInvoiceLedesForm.vue?vue&type=template&id=39b7be9c&scoped=true&"
import script from "./CreateLawInvoiceLedesForm.vue?vue&type=script&lang=js&"
export * from "./CreateLawInvoiceLedesForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateLawInvoiceLedesForm.vue?vue&type=style&index=0&id=39b7be9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b7be9c",
  null
  
)

export default component.exports